import { omit } from 'ramda';

import { TransferInput } from '__generated__/GQL';
import { MergeExclusiveRight } from 'common/typesUtils';

import { Transfer } from '../../types';

export const formatTransfer: (
  transfer: Transfer,
) => MergeExclusiveRight<Transfer, TransferInput> = (transfer) => {
  const bankTransferRecipient: MergeExclusiveRight<
    Transfer['bankTransferRecipient'],
    TransferInput['bankTransferRecipient']
  > = {
    ...omit(
      ['__typename', 'bankTransferRecipientId'],
      transfer.bankTransferRecipient,
    ),
    ...(transfer.bankTransferRecipient.bankTransferRecipientId && {
      bankTransferRecipientId:
        transfer.bankTransferRecipient.bankTransferRecipientId,
    }),
  };

  const transferToSend = omit(['__typename', 'errors'], transfer);

  return { ...transferToSend, bankTransferRecipient };
};
